var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeThumbs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.743,
    height: 16.004,
    viewBox: "0 0 16.743 16.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16727",
    "data-name": "Rectangle 16727",
    width: 16.743,
    height: 16.004,
    fill: "#5e829f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17420",
    "data-name": "Group 17420",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17419",
    "data-name": "Group 17419",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41595",
    "data-name": "Path 41595",
    d: "M5.915,14.784a1.423,1.423,0,0,1-1.007.819,1.873,1.873,0,0,1-.373.031q-1.522,0-3.044,0A1.4,1.4,0,0,1,0,14.136q0-3.5,0-7.008A1.408,1.408,0,0,1,1.517,5.617c1.115,0,2.23,0,3.344,0a.284.284,0,0,0,.3-.187C5.564,4.622,6,3.827,6.382,3a15.38,15.38,0,0,0,.527-1.522,2.084,2.084,0,0,1,3.906-.217A6.172,6.172,0,0,1,11.286,3a5.682,5.682,0,0,1-.146,1.545c-.04.228-.087.455-.126.683s.035.307.262.3c.75-.038,1.5-.084,2.251-.123A2.994,2.994,0,0,1,16.7,7.89a3.589,3.589,0,0,1-.056,1.324c-.228,1.243-.431,2.49-.677,3.73a3.761,3.761,0,0,1-3.632,3.047c-1.321.026-2.643.009-3.964,0a2.227,2.227,0,0,1-1.266-.413c-.392-.268-.789-.528-1.193-.8M6.028,9.9c0,1.115,0,2.229,0,3.344a.286.286,0,0,0,.147.273q.818.533,1.627,1.079a1.142,1.142,0,0,0,.654.2c1.259,0,2.518.01,3.776,0a2.576,2.576,0,0,0,2.579-2.161q.37-1.945.7-3.9A1.792,1.792,0,0,0,13.57,6.6c-.788.043-1.575.1-2.363.121A1.385,1.385,0,0,1,9.821,5.061c.04-.222.087-.442.122-.664A3.7,3.7,0,0,0,10.067,3,12.186,12.186,0,0,0,9.694,1.71a.762.762,0,0,0-.57-.474.881.881,0,0,0-1.065.6c-.227.634-.421,1.284-.7,1.9-.382.842-.832,1.653-1.246,2.481a.793.793,0,0,0-.082.338c-.006,1.115,0,2.229,0,3.344M4.806,6.83c-.072,0-.116-.008-.16-.008H1.509c-.252,0-.3.054-.3.313q0,3.494,0,6.988c0,.253.055.307.308.307H4.464c.324,0,.348-.025.348-.357q0-3.522-.006-7.044c0-.061,0-.123,0-.2",
    transform: "translate(0 0)",
    fill: "#5e829f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41596",
    "data-name": "Path 41596",
    d: "M33.27,161c0,.144.006.288,0,.431a.593.593,0,0,1-.549.565.563.563,0,0,1-.619-.456,5.507,5.507,0,0,1,0-1.081.564.564,0,0,1,.612-.467.6.6,0,0,1,.559.577c.006.143,0,.287,0,.431",
    transform: "translate(-29.662 -147.963)",
    fill: "#5e829f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeThumbs);
export default __webpack_public_path__ + "static/media/like_thumbs.e0705146c1f90deb33f105dc5737cfc4.svg";
export { ForwardRef as ReactComponent };